import { useState } from 'react';

import { useMenuHeaderLang } from './useMenuHeaderLang';

import type { ChangeEvent } from 'react';

export function useMenuHeader(props: Props) {
  const { onSearch, refreshCatalog } = props;

  const [isLoadingCatalog, setIsLoadingCatalog] = useState(false);
  const [openStoreSelector, setOpenStoreSelector] = useState(false);

  const lang = useMenuHeaderLang();

  const handleRefreshCatalog = () => {
    refreshCatalog();
    setIsLoadingCatalog(true);
    setTimeout(() => setIsLoadingCatalog(false), 1_200);
  };

  const handleOpenStoreSelector = () => setOpenStoreSelector(true);

  const handleCloseStoreSelector = () => setOpenStoreSelector(false);

  const handleClear = () => onSearch('');

  const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    onSearch(event.target.value);
  };

  return {
    lang,
    isLoadingCatalog,
    openStoreSelector,
    handleRefreshCatalog,
    handleOpenStoreSelector,
    handleCloseStoreSelector,
    handleClear,
    handleSearch,
  };
}
interface Props {
  onSearch: (v: string) => void;
  refreshCatalog: () => void;
}
